import { ApolloClient, InMemoryCache, from } from '@apollo/client/core';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from '@apollo/client/link/error';

const errorHandler = onError(({ networkError, response, operation }) => {
  if (networkError && networkError.statusCode === 401) {
    window.location = process.env.VUE_APP_API_URL + `/auth/login`;
  }

  if (operation.operationName === 'GetAkun') {
    response.errors = null;
  }
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
  //@ts-ignore
  link: from([
    createUploadLink({
      uri: process.env.VUE_APP_API_URL + '/graphql',
      fetch,
      fetchOptions: { credentials: 'include' },
    }),
    errorHandler,
  ]),
  credentials: 'include',
  cache,
});

export default apolloClient;
